import React, { useState, useEffect } from "react";
import { useLocation, useHistory, Link } from "react-router-dom";
import ManageSellerReports from "./ManageSellerReports";
import Reports from "./Reports";

const SellerReports = () => {
  const history = useHistory();
  const param = history.location.pathname.split("/");

  return param.includes("managereports") ? (
    <ManageSellerReports />
  ) : (
    <Reports />
  );
};

export default SellerReports;
